export enum TemplateTypes{
    QuoteDefault = 1,
    InvoiceDefault = 2,
    PurchaseOrderDefault = 3,
}